
const DatePickerLocalCN = {
  lang: {
      now: "此时",
      ok: "确定",
  //   locale: 'zh_cn',
  //   placeholder: '选择日期',
  //   rangePlaceholder: ['开始日期', '结束日期'],
  //   today: '今天',
  //   now: '此刻',
  //   backToToday: '返回今天',
  //   ok: '确定',
  //   clear: '清除',
  //   month: '月',
  //   year: '年',
    timeSelect: '选择时间',
    dateSelect: '选择日期',
    monthSelect: '选择月份',
    yearSelect: '选择年份',
    decadeSelect: '选择年代',
    yearFormat: 'YYYY年',
    dateFormat: 'M/D/YYYY',
    dayFormat: 'D日',
    // dateTimeFormat: 'M/D/YYYY HH:mm',
    // monthFormat: 'M月',
    // monthBeforeYear: true,
    // previousMonth: 'Previous month (PageUp)',
    // nextMonth: 'Next month (PageDown)',
    // previousYear: '上一年 (Control键加左方向键)',
    // nextYear: '下一年 (Control键加右方向键)',
    // previousDecade: '上一年代',
    // nextDecade: '下一年代',
    // previousCentury: '上一世纪',
    // nextCentury: '下一世纪'
  // },
  // timePickerLocale: {
  //   placeholder: '选择时间'
  // // },
  // dateFormat: 'YYYY-MM-DD',
  // dateTimeFormat: 'YYYY-MM-DD HH:mm',
  // weekFormat: 'YYYY-wo',
  // monthFormat: 'YYYY-MM'
}
}
export default DatePickerLocalCN



// WEBPACK FOOTER //
// ./src/utils/TimeDate.js